import React from "react";
import { Reveal } from "./useReveal";
import { LOGO_URL } from "./Logo";

const PhoneFrame = ({ className = "" }) => (
  <div
    data-testid="preview-phone"
    className={`relative mx-auto w-[240px] md:w-[260px] aspect-[9/19] bg-[#1A1A1A] rounded-[32px] p-2 shadow-[0_30px_60px_-30px_rgba(26,26,26,0.35)] ${className}`}
  >
    <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#1A1A1A] rounded-b-xl z-10" />
    <div className="w-full h-full bg-[#F5F0E8] rounded-[26px] overflow-hidden relative flex flex-col">
      <div className="flex items-center justify-between px-5 pt-7 pb-3 text-[10px] text-[#1A1A1A]/60">
        <span>9:41</span>
        <span>●●●●●</span>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <img
          src={LOGO_URL}
          alt="MahjongTrainer"
          className="w-full max-w-[180px] h-auto select-none"
          draggable="false"
        />
        <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#3D7A5A] font-bold">
          Coming soon
        </p>
        <p className="mt-2 text-[13px] text-[#3a3a38] leading-relaxed">
          Play. Learn. Master.
        </p>
      </div>
      <div className="pb-6 flex justify-center">
        <div className="w-20 h-1 bg-[#1A1A1A]/20 rounded-full" />
      </div>
    </div>
  </div>
);

const BrowserFrame = ({ className = "" }) => (
  <div
    data-testid="preview-browser"
    className={`hidden md:flex flex-col w-full max-w-[560px] bg-[#1A1A1A] rounded-md shadow-[0_30px_60px_-30px_rgba(26,26,26,0.35)] ${className}`}
  >
    <div className="flex items-center gap-1.5 px-4 py-2.5">
      <span className="w-2.5 h-2.5 rounded-full bg-[#C0392B]" />
      <span className="w-2.5 h-2.5 rounded-full bg-[#E5DFD3]" />
      <span className="w-2.5 h-2.5 rounded-full bg-[#3D7A5A]" />
      <div className="ml-4 px-3 py-1 rounded-sm bg-[#2a2a2a] text-[11px] text-[#F5F0E8]/60 font-mono">
        mahjongtrainer.com
      </div>
    </div>
    <div className="bg-[#F5F0E8] rounded-b-md p-10 flex flex-col items-center text-center aspect-[16/10] justify-center">
      <img
        src={LOGO_URL}
        alt="MahjongTrainer"
        className="max-w-[280px] w-full h-auto"
        draggable="false"
      />
      <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#3D7A5A] font-bold">
        Coming soon
      </p>
      <p className="mt-2 text-[14px] text-[#3a3a38] leading-relaxed max-w-xs">
        The first Claude AI coach for Hong Kong Cantonese Mahjong.
      </p>
    </div>
  </div>
);

const AppPreview = () => {
  return (
    <section
      id="preview"
      data-testid="app-preview-section"
      className="relative bg-[#F5F0E8] py-20 md:py-32 overflow-hidden border-t border-[#E5DFD3]"
    >
      {/* Subtle jade radial backdrop */}
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-[900px] aspect-square rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at center, rgba(61, 122, 90, 0.16) 0%, rgba(61, 122, 90, 0.04) 45%, transparent 70%)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-5 md:px-8 text-center">
        <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-[#3D7A5A] mb-4">
          App Preview
        </p>
        <h2
          data-testid="preview-headline"
          className="text-3xl sm:text-4xl md:text-[44px] leading-[1.1] tracking-tight text-[#1A1A1A]"
        >
          <span className="font-black">A sneak peek</span>{" "}
          <span className="font-light">at what's coming.</span>
        </h2>

        <Reveal className="mt-14 md:mt-20 flex flex-col md:flex-row items-center justify-center gap-10 md:gap-14">
          <BrowserFrame />
          <PhoneFrame />
        </Reveal>

        <p className="relative mt-12 md:mt-16 text-sm md:text-base text-[#6b6a64] max-w-md mx-auto">
          Early access members help shape the product — from features to
          courses to community events.
        </p>
      </div>
    </section>
  );
};

export default AppPreview;
